<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  options: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const gridClass = computed(() => {
  if (props.options.length === 3) return 'grid-cols-3';
  if (props.options.length === 4) return 'grid-cols-4';
  return 'grid-cols-2';
});
</script>

<template>
  <div class="grid gap-2" :class="gridClass">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="flex h-8 items-center justify-center rounded-xl border text-[11px] font-semibold transition"
      :class="
        modelValue === option.value
          ? 'border-[#128c7e] bg-[#128c7e] text-white shadow-sm'
          : 'border-black/10 bg-n-slate-1 text-n-slate-11 hover:bg-n-slate-2'
      "
      @click.stop="emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
